import script from "./suc.vue?vue&type=script&setup=true&lang=js"
export * from "./suc.vue?vue&type=script&setup=true&lang=js"

import "./suc.vue?vue&type=style&index=0&id=5468ab36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5468ab36"]])

export default __exports__